import React from "react";
import { Link } from "react-router-dom";
import { Heart, Navigation } from "lucide-react";
import { locationService } from "../services/locationService";

export default function LocationCard({ item, isFav, onFav }) {
  const thumb = typeof item?.image?.url === "string" ? item.image.url.trim() : "";
  const hasThumb = Boolean(thumb);

  const detailTo = `/location/${encodeURIComponent(String(item.slug || ""))}`;

  const bumpView = () => {
    const slug = String(item.slug || "").trim();
    if (!slug) return;
    try {
      locationService.bumpViewBySlug(slug).catch(() => {});
    } catch {
      // ignore
    }
  };

  const shortLine =
    (item.shortIntro && String(item.shortIntro).trim()) ||
    (item.description &&
      String(item.description)
        .replace(/<[^>]+>/g, " ")
        .replace(/\s+/g, " ")
        .trim()
        .slice(0, 110)) ||
    "";

  return (
    <article className="group overflow-hidden rounded-2xl border border-[#d8cfbf] bg-[#fffdf8] shadow-[0_8px_24px_rgba(80,70,40,0.06)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_32px_rgba(80,70,40,0.10)]">
      <div className="relative">
        <Link to={detailTo} onClick={bumpView} className="block">
          <div className="aspect-[4/3] overflow-hidden bg-[#ece4d7]">
            {hasThumb ? (
              <img
                src={thumb}
                alt={item.name}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                onError={(e) => {
                  // If the real image fails, show the "updating" placeholder instead of a default image.
                  const img = e.currentTarget;
                  img.onerror = null;
                  img.style.display = "none";
                  const parent = img.parentElement;
                  if (parent) parent.setAttribute("data-noimg", "1");
                }}
              />
            ) : null}
            {!hasThumb ? (
              <div className="flex h-full w-full items-center justify-center px-4 text-center">
                <span className="rounded-lg border border-[#d8cfbf] bg-[#fffdf8]/80 px-3 py-2 text-xs font-semibold text-[#6f776b]">
                  Ảnh đang cập nhật
                </span>
              </div>
            ) : null}
            {/* If img exists but errors out, CSS hook to show the same text */}
            <div className="hidden h-full w-full items-center justify-center px-4 text-center [data-noimg='1']:&flex">
              <span className="rounded-lg border border-[#d8cfbf] bg-[#fffdf8]/80 px-3 py-2 text-xs font-semibold text-[#6f776b]">
                Ảnh đang cập nhật
              </span>
            </div>
          </div>
        </Link>

        <Link
          to={detailTo}
          onClick={bumpView}
          className="absolute bottom-2 right-2 inline-flex items-center justify-center rounded-md bg-[#fffdf8]/95 px-2.5 py-1 text-[11px] font-bold text-[#3f4b3d] shadow-sm ring-1 ring-[#d8cfbf] backdrop-blur transition hover:bg-[#fffaf1] hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-[#65745f]/40"
          aria-label={`More info: ${item.name}`}
        >
          more info
        </Link>
      </div>

      <div className="border-t border-[#ddd4c6]">
        <div className="border-b border-[#ddd4c6] px-4 pt-2 pb-1">
          <h3 className="line-clamp-2 text-sm font-extrabold uppercase tracking-wide leading-tight text-[#2f3a31]">
            <Link
              to={detailTo}
              onClick={bumpView}
              className="transition-colors hover:text-[#65745f]"
            >
              {item.name}
            </Link>
          </h3>
        </div>

        <div className="border-b border-[#ddd4c6]">
          <div className="min-h-[86px] px-4 py-2">
            <p className="line-clamp-3 text-xs leading-relaxed text-[#5f675b]">
              {shortLine || <span className="italic text-[#9a9285]">Chưa có mô tả ngắn</span>}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2">
          <a
            href={`https://www.google.com/maps?q=${item.latitude},${item.longitude}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 border-r border-[#ddd4c6] bg-[#65745f] px-4 py-3 text-sm font-bold text-white transition hover:bg-[#586652]"
          >
            <Navigation size={16} />
            Chỉ đường
          </a>

          <button
            type="button"
            onClick={() => onFav(item.id)}
            aria-pressed={isFav}
            className={`inline-flex items-center justify-center gap-2 border-l border-[#ddd4c6] px-4 py-3 text-sm font-bold transition ${
              isFav
                ? "bg-[#a85d5d] text-white shadow-inner hover:bg-[#934f4f]"
                : "bg-[#ede3d1] text-[#5e6858] hover:bg-[#e3d8c3]"
            }`}
          >
            <span
              className={`inline-flex h-6 w-6 items-center justify-center rounded-full ${
                isFav ? "bg-white/20" : "bg-[#d9ccb4]"
              }`}
            >
              <Heart
                size={14}
                className={isFav ? "fill-current" : ""}
                strokeWidth={isFav ? 2.2 : 2}
              />
            </span>
            {isFav ? "Đã thích" : "Thêm yêu thích"}
          </button>
        </div>
      </div>
    </article>
  );
}